import { useEffect } from 'react';
import { useSelector, useStore } from 'react-redux';

import { selectIsConnectingAgent, selectIsLiveChat } from '../../common/selectors/chat';
import { subscribeCopilotToMessages } from '../../messageChannel/CopilotMessageSubscriber';
import { copilotReadyToBeInitialized, copilotUpdadeChatFlow } from '../../messageChannel/postNewMessages';
import { renderModel } from '../../util/renderModel';
import { useUserActionSendMessage } from './userActions';

export const useCopilotMessageSubscriber = () => {
  const store = useStore();
  const isConnectingAgent = useSelector(selectIsConnectingAgent);
  const isliveChat = useSelector(selectIsLiveChat);
  const sendMessage = useUserActionSendMessage();
  const isCopilot = renderModel.isCopilot();

  useEffect(() => {
    if (isConnectingAgent || isliveChat) {
      copilotUpdadeChatFlow('contact_flow');
    } else {
      copilotUpdadeChatFlow('regular_flow');
    }
  }, [isConnectingAgent, isliveChat]);

  useEffect(() => {
    if (isCopilot) {
      copilotReadyToBeInitialized();
    }
  }, [isCopilot]);

  useEffect(() => {
    if (!isCopilot) {
      return;
    }

    const unsubscribeCopilot = subscribeCopilotToMessages(store, (msg: string) =>
      sendMessage({
        value: msg,
        action_type: 'click',
        attachments: [],
        isLiveChat: false,
      }),
    );

    return () => unsubscribeCopilot();
  }, [store, sendMessage, isCopilot]);
};
